const QUARRY_BY_NODE = {
  1: ["Gorm", "Crimson Crocodile", "White Lion"],
  2: ["Screaming Antelope", "Spidicules", "Flower Knight", "Smog Singers"],
  3: ["Phoenix", "Dragon King", "Sunstalker"],
  4: ["Dung Beetle Knight", "Lion God", "The King"],
};

const NEMESIS_BY_NODE = {
  1: ["Butcher", "Manhunter"],
  2: ["King's Man", "Lion Knight", "Slenderman", "Atnas"],
  3: ["The Hand"],
};

const CC_REWARDS = [
  { at: 1, name: "Facets of Power" },
  { at: 2, name: "Pleasing Plating" },
  { at: 5, name: "Comprehensive Construction" },
  { at: 6, name: "Crimson Crocodile Cousine" },
  { at: 8, name: "Communal Larder" },
  { at: 13, name: "Sated Enlightenment" },
  { at: 16, name: "Smog Singer Cuisine" },
  { at: 21, name: "Metabolic Improvements" },
  { at: 26, name: "Phoenix Cuisine" },
  { at: 30, name: "Shared Illumination" },
  { at: 36, name: "King Cuisine" },
  { at: 46, name: "Culinary Ingenuity" },
];

function hasPillar(pillars, name) {
  const list = Array.isArray(pillars) ? pillars : [];
  const n = String(name || "").trim().toLowerCase();
  return list.some((p) => String(p).trim().toLowerCase() === n);
}

function numOrZero(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function clampInt(v, min, max) {
  const n = Math.trunc(numOrZero(v));
  if (!Number.isFinite(n)) return min;
  return Math.min(max, Math.max(min, n));
}

function romanToNumber(roman) {
  const map = { I: 1, II: 2, III: 3, IV: 4, V: 5 };
  return map[String(roman || "").trim()] ?? 999;
}

function parseLegacyList(text) {
  const raw = String(text || "").trim();
  if (!raw) return [];
  const parts = raw
    .split(/\r?\n|,/g)
    .map((s) => s.trim())
    .filter(Boolean);

  const seen = new Set();
  const out = [];
  for (const p of parts) {
    const key = p.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(p);
  }
  return out;
}

function ensureBoolArrayLen(arr, len) {
  const a = Array.isArray(arr) ? arr.slice() : [];
  while (a.length < len) a.push(false);
  if (a.length > len) a.length = len;
  return a;
}

function toggleBoolAt(arr, idx) {
  const next = arr.slice();
  next[idx] = !next[idx];
  return next;
}



function countChecked(arr) {
  if (!Array.isArray(arr)) return 0;
  return arr.reduce((n, v) => (v ? n + 1 : n), 0);
}

function getSurvivorQuickStats(survivor, useArc) {
  const sheet = survivor.sheet || {};

  const stats = (sheet.stats ?? null);

  const baseStats = {
    mov: stats?.movement?.base ?? 5,
    acc: stats?.accuracy?.base ?? 0,
    str: stats?.strength?.base ?? 0,
    eva: stats?.evasion?.base ?? 0,
    luc: stats?.luck?.base ?? 0,
    spd: stats?.speed?.base ?? 0,
  };

  const courage = (sheet.courageCheckboxes ?? Array(9).fill(false));
  const understanding = (sheet.understandingCheckboxes ?? Array(9).fill(false));
  const weaponProf = (sheet.weaponProficiency ?? Array(8).fill(false));
  const selectedWeapon = (sheet.selectedWeapon ?? "");
  const deceased = (sheet.deceased ?? false);

  const scope = useArc ? "arc" : "character";
  const huntXP = (sheet[`${scope}__huntXP`] ?? Array(16).fill(false));

  return {
    huntXPCount: countChecked(huntXP),
    courageCount: countChecked(courage),
    understandingCount: countChecked(understanding),
    weaponProfCount: countChecked(weaponProf),
    weaponName: typeof selectedWeapon === "string" ? selectedWeapon : "",
    deceased: !!deceased,
    baseStats,
  };
}

function prettyKeyToTitle(key) {
  const s = String(key || "").trim();
  if (!s) return "";
  const spaced = s.replace(/([a-z])([A-Z])/g, "$1 $2");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}


export { QUARRY_BY_NODE, NEMESIS_BY_NODE, CC_REWARDS, hasPillar, numOrZero, clampInt, romanToNumber, parseLegacyList, ensureBoolArrayLen, toggleBoolAt, countChecked, getSurvivorQuickStats, prettyKeyToTitle };
